export default __webpack_public_path__ + "static/media/sar_adc_mlg.aefdcd89.png";